'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { Input, Stack, Text } from '@chakra-ui/react'
import { Button } from '@/components/ui/button'
import { CField } from '../../../CField'
import { IUser } from '@/app/[locale]/_store/types'

interface IProps {
  formData: IUser
  errors: { name?: string }
  loading: boolean
  onChange: (value: string, name: string) => void
}

function RegisterMobile({ formData, errors, loading, onChange }: IProps) {
  const [acceptPolicy, setAcceptPolicy] = useState(true)

  const t = useTranslations()

  return (
    <div>
      <Text color={'text'} fontSize='2xl' fontWeight={700} mb={6}>
        {t('personal_data')}
      </Text>
      <Stack gap={4}>
        <CField label={t('your_name')} bgColor='background' color={'text'}>
          <Input
            placeholder=''
            className='peer'
            value={formData.name}
            onChange={(e) => onChange(e.target.value, 'name')}
            borderColor={errors.name ? 'red.500' : 'inherit'}
          />
          {errors.name && (
            <Text color='red.500' fontSize='sm'>
              {errors.name}
            </Text>
          )}
        </CField>
      </Stack>
      <Button
        type='submit'
        size='xl'
        mt={4}
        w='full'
        height='56px'
        fontWeight={600}
        fontSize='md'
        bg='primary'
        color='primary.text'
        _hover={{
          bg: 'primary.hover',
        }}
        loading={loading}
        disabled={!acceptPolicy}
      >
        {t('save')}
      </Button>
    </div>
  )
}

export default RegisterMobile
